import { render, staticRenderFns } from "./CampaignOverview.vue?vue&type=template&id=94cdaff8&scoped=true&"
import script from "./CampaignOverview.vue?vue&type=script&lang=ts&"
export * from "./CampaignOverview.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignOverview.vue?vue&type=style&index=0&id=94cdaff8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cdaff8",
  null
  
)

export default component.exports